// Acente havuz filtrelerinde tek şubeli (fiilen dedike) havuzları elemek için ortak kural.
export const isRealPool = pool => (pool?.subCompanies?.length ?? 0) > 1;
